import type { LucideIcon } from "lucide-react";
import {
  Award,
  Clock,
  Shield,
  ShoppingBag,
  TrendingUp,
  Truck,
  Users,
  Warehouse,
  Wrench,
} from "lucide-react";

const DEFAULT_ICON = Warehouse;

/** Icon keys from GET /home → homeAdvantages[].icon */
const homeAdvantageKeys = {
  warehouse: Warehouse,
  truck: Truck,
  award: Award,
  shield: Shield,
} as const satisfies Record<string, LucideIcon>;

/** Icon keys from GET /about → aboutAdvantages[].icon */
const aboutAdvantageKeys = {
  award: Award,
  users: Users,
  warehouse: Warehouse,
  shield: Shield,
  wrench: Wrench,
  truck: Truck,
} as const satisfies Record<string, LucideIcon>;

/** Icon keys from GET /account/dashboard → dashboardStats[].icon */
const dashboardStatKeys = {
  "shopping-bag": ShoppingBag,
  "trending-up": TrendingUp,
  clock: Clock,
} as const satisfies Record<string, LucideIcon>;

export function getHomeAdvantageIcon(key: string): LucideIcon {
  return homeAdvantageKeys[key as keyof typeof homeAdvantageKeys] ?? DEFAULT_ICON;
}

export function getAboutAdvantageIcon(key: string): LucideIcon {
  return aboutAdvantageKeys[key as keyof typeof aboutAdvantageKeys] ?? DEFAULT_ICON;
}

export function getDashboardStatIcon(key: string): LucideIcon {
  return dashboardStatKeys[key as keyof typeof dashboardStatKeys] ?? ShoppingBag;
}
